import React from "react";
import BaseButton from "../BaseButton";

export default function AttributeSelectionBox({
  children,
  onClick,
  isLastElement,
  ...rest
}) {
  return (
    <BaseButton onClick={onClick} className="w-full" {...rest}>
      <div
        className={`w-full ${
          isLastElement ? "" : "border-b border-grey-light"
        }`}
      >
        {children}
      </div>
    </BaseButton>
  );
}



// WEBPACK FOOTER //
// ./src/AttributeSelectionBox/AttributeSelectionBox.js